idLikeTo();

function idLikeTo() {
    let $idLikeToSlideout = $('#idLikeToSlideout'),
        $idLikeToSlideoutClose = $idLikeToSlideout.find('#idLikeToSlideoutClose'),
        $idLikeToSlideoutOpen = $('#idLikeTo').find('> button'),
        $idLikeToMenuToggle = $idLikeToSlideout.find('.idLikeToMenuToggle');

    // Close slideout
    $idLikeToSlideoutClose.on('click', function () {
        $('body').removeClass('prevent-scrolling');
        remove_trap_focus($idLikeToSlideout, 'id_like_to');
        closeSlideout();
    });

    // Open slideout
    $idLikeToSlideoutOpen.on('click', function () {
        $idLikeToSlideoutOpen.attr('aria-expanded', true);
        $('body').addClass('prevent-scrolling');

        let $idLikeToSlideout = $('#' + $idLikeToSlideoutOpen.attr('aria-controls'));

        $idLikeToSlideout.show(function () {
            $idLikeToSlideout.addClass('is-shown');
            trap_focus($idLikeToSlideout, 'id_like_to');
        });
    });

    // Toggle slideout menu
    $idLikeToMenuToggle.on('click', function () {
        $(this).attr('aria-expanded', ($(this).attr('aria-expanded') === 'true' ? false : true));
    });

    // Close slideout if clicked outside of it
    $('#idLikeToSlideoutOverlay').on('click', function () {
        closeSlideout();
    });

    function closeSlideout() {
        $idLikeToSlideoutOpen.attr('aria-expanded', false);
        $('body').removeClass('prevent-scrolling');

        let $idLikeToSlideout = $('#' + $idLikeToSlideoutOpen.attr('aria-controls'));

        $idLikeToSlideout.show(function () {
            $idLikeToSlideout.removeClass('is-shown');
            $idLikeToSlideout.one('transitionend', function () {
                $idLikeToSlideout.hide();
            });
        });
    }
}



